import { render, staticRenderFns } from "./LoadingBusy.vue?vue&type=template&id=66b69f4e&"
import script from "./LoadingBusy.vue?vue&type=script&lang=js&"
export * from "./LoadingBusy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports